module.exports = __webpack_public_path__ + "static/media/action_img.5368732e.png";